<app-base-layout>
    <!-- DESKTOP LAYOUT -->
    @if (!isMobile()) {
    <mat-sidenav-container class="h-screen">
        <!-- Quickpanel desktop -->
        <mat-sidenav #quickpanel mode="over" position="end" class="w-70 bg-pmdf-surface">
            <app-quickpanel class="h-full" />
        </mat-sidenav>

        <!-- Conteúdo desktop -->
        <mat-sidenav-content class="flex flex-col h-full">
            <!-- 1. Toolbar (linha 1) -->
            <app-toolbar (toggleQuickpanelRequest)="toggleQuickpanel()" (toggleSidenavRequest)="toggleSidenavExpanded()"
                class="shrink-0 z-30" />

            <!-- 2. Conteúdo principal (linha 2 - flex horizontal) -->
            <div class="flex flex-1 overflow-hidden">
                <!-- Sidebar esquerda -->
                <aside [class]="sidenavWidthClass()" class="shrink-0 h-full overflow-hidden transition-all duration-300">
                    <app-sidenav [expanded]="sidenavExpanded()" class="h-full" />
                </aside>

                <!-- Conteúdo principal -->
                <div class="flex flex-col flex-1 overflow-hidden">
                    <app-version-bar class="shrink-0" />

                    <main class="flex-1 overflow-y-auto bg-pmdf-bg-muted">
                        <div class="p-4 md:p-6 lg:p-8">
                            <router-outlet />
                        </div>
                    </main>

                    <app-footer class="shrink-0" />
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
    }

    <!-- MOBILE LAYOUT -->
    @if (isMobile()) {
    <div class="flex flex-col h-screen">
        <!-- Toolbar fixo no topo (fora do sidenav-container) -->
        <app-toolbar (toggleQuickpanelRequest)="toggleQuickpanel()" class="shrink-0 z-50" />

        <!-- Container para sidenav + conteúdo (ocupa espaço entre toolbar e bottom nav) -->
        <mat-sidenav-container class="flex-1 overflow-hidden">
            <!-- Sidenav mobile -->
            <mat-sidenav mode="over" [opened]="sidenavOpened()" (closedStart)="closeSidenav()" position="start"
                class="w-70">
                <app-sidenav [expanded]="true" class="h-full" />
            </mat-sidenav>

            <!-- Quickpanel mobile -->
            <mat-sidenav #quickpanel mode="over" position="end" class="w-70 bg-pmdf-surface">
                <app-quickpanel class="h-full" />
            </mat-sidenav>

            <!-- Conteúdo mobile -->
            <mat-sidenav-content class="flex flex-col h-full">
                @if (!hideVersionBar()) {
                  <app-version-bar class="shrink-0" />
                }

                <!-- Main com scroll e espaço para navigation fixo -->
                <main class="flex-1 overflow-y-auto bg-pmdf-bg-muted">
                    <!-- Container do conteúdo com altura mínima e padding inferior -->
                    <div class="min-h-full flex flex-col pb-16">
                        <!-- Conteúdo da página -->
                        <div class="flex-1">
                            <router-outlet />
                        </div>
                    </div>
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>

        <!-- Bottom Navigation -->
        <app-navigation class="shrink-0" />
    </div>
    }

    <!-- FAB (contextual) -->
    @if (currentFAB()) {
    <button mat-fab [extended]="!isMobile()" [color]="currentFAB()!.color" (click)="onFABClick()"
        [attr.aria-label]="currentFAB()!.ariaLabel"
        [class.bottom-20]="isMobile()" [class.right-4]="isMobile()"
        [class.bottom-6]="!isMobile()" [class.right-6]="!isMobile()"
        class="fab fixed z-40 shadow-xl transition-all duration-300">
        <mat-icon class="icon-lg">{{ currentFAB()!.icon }}</mat-icon>
        @if (!isMobile()) {
        <span class="ml-2">{{ currentFAB()!.ariaLabel }}</span>
        }
    </button>
    }

    <!-- COPILOTO IA PROVID (GLOBAL DRAWER) -->
    <app-copilot-drawer />

</app-base-layout>